import React from 'react';
import { Badge, BadgePriority } from '@wix/wix-ui-tpa/cssVars';

import { classes, st } from './StatusBadge.st.css';

export enum StatusBadgeIndicatorType {
  ON = 'on',
  OFF = 'off',
  NONE = 'none',
}

export type StatusBadgeProps = {
  dataHook?: string;
  indicator: StatusBadgeIndicatorType;
  text: string;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  dataHook,
  indicator,
  text,
}) => {
  const icon =
    indicator === StatusBadgeIndicatorType.NONE ? undefined : (
      <span
        className={st(classes.indicator, {
          on: indicator === StatusBadgeIndicatorType.ON,
        })}
      />
    );

  return (
    <Badge
      className={classes.root}
      data-hook={dataHook}
      priority={BadgePriority.light}
      icon={icon}
    >
      {text}
    </Badge>
  );
};

export default StatusBadge;
